import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/$orgSlug/$projectId')({
  component: ProjectLayout
})

function ProjectLayout() {
  return <Outlet />
}
